const ShampanMass=[
          {
            id: 1,
            title: 'Serena 1881 «Frizzante PIU» (Італія) біл н/сух 0,75',
            price: '750 грн',
            src: require('../img/proseco1881.png'),
            text: '100мл - 100 грн',
          },
    {
        id:2,
        title:"Просеко кег 150 мл",
        price:"100 грн",
        src: require('../img/prossecoKeg.png'),
        text:"",
    },
    {
        id:3,
        title:"Моет і Шандон Імперіаль (Франція) ігр.,брют біле 0,75л",
        price:"3020 грн",
        src: require('../img/moet.png'),
        text:"",
    },
    {
        id:4,
        title:"Terra Serena «Prosecco Frizante» (Італія) ігристе, біл./сух. 0,75л",
        price:"750 грн",
        src: require('../img/proseco.webp'),
        text:"100мл - 100 грн",
    },
    {
        id:5,
        // title:"Latinium Sparkling Rose, рожеве напівсолодке 0.75 л",
        title:"Latinium, Peter Mertes «Sparkling» (Німеччина) ігристе, біл./напівсол. 0,75л",
        price:"540 грн",
        src: require('../img/sparkling.webp'),
        text:"",
    },
    {
        id:6,
        title:"San Mare Fragolino Rosso (Італія) сол./чер. 0,75 л",
        price:"600 грн",
        src: require('../img/fragolinor.webp'),
        text:"100мл - 80 грн",
    },
    {
        id:7,
        title:"San Mare Pesca «Зі смаком персика » (Італія) напівсол./біл. 0,75 л",
        price:"600 грн",
        src: require('../img/fragolinob.webp'),
        text:"100мл - 80 грн",
    },
    {
        id:8,
        title:"San Mare Bianco «Зі смаком полуниці » (Італія) сол./біл. 0,75 л",
        price:"600 грн",
        src: require('../img/SanMareFragolino.png'),
        text:"100мл - 80 грн",
    },
    {
        id:9,
        title:"Маренго брют (Україна) сух./біл. 0,75л",
        price:"495 грн",
        src: require('../img/marengob.webp'),
        text:"100мл - 66 грн",
    },
    {
        id:10,
        title:"Маренго біле солодке (Україна) сол./біл. 0,75л",
        price:"495 грн",
        src: require('../img/marengos.webp'),
        text:"100мл - 66 грн",
    },
    {
        id:11,
        title:"Маренго рожеве напівсолодке (Україна) напівсол./рож. 0,75л",
        price:"495 грн",
        src: require('../img/mangor.png'),
        text:"100мл - 66 грн",
    },
    
    
]

export default ShampanMass;